export const Types = {
  getCampaigns: 'campaign/GET_CAMPAIGNS',
  updateCampaigns: 'campaign/UPDATE_CAMPAIGNS',
  updateCampaign: 'campaign/UPDATE_CAMPAIGN',
  getCampaignStoreRules: 'campaign/GET_CAMPAIGN_STORE_RULES',
  updateCampaignStoreRules: 'campaign/UPDATE_CAMPAIGN_STORE_RULES',
  updateSelectedDays: 'campaign/UPDATE_SELECTED_DAYS',
  reset: 'campaign/RESET',
  getCampaignFields: 'campaign/GET_CAMPAIGN_FIELDS',
  updateCampaignFields: 'campaign/UPDATE_CAMPAIGN_FIELDS'
}

export function getCampaigns ({ storeId } = {}) {
  return {
    type: Types.getCampaigns,
    payload: { storeId }
  }
}

export function updateCampaigns ({ campaigns = [], error } = {}) {
  return {
    type: Types.updateCampaigns,
    payload: { campaigns, error }
  }
}

export function updateCampaign ({ campaign = {} } = {}) {
  return {
    type: Types.updateCampaign,
    payload: { campaign }
  }
}

export function getCampaignStoreRules ({ campaignId } = {}) {
  return {
    type: Types.getCampaignStoreRules,
    payload: { campaignId }
  }
}

export function updateCampaignStoreRules ({ storeRules = [], error } = {}) {
  return {
    type: Types.updateCampaignStoreRules,
    payload: { storeRules, error }
  }
}

export function updateSelectedDays ({ selectedDays = [] } = {}) {
  return {
    type: Types.updateSelectedDays,
    payload: { selectedDays }
  }
}

export function reset () {
  return {
    type: Types.reset
  }
}

export function getCampaignFields ({ campaignId } = {}) {
  return {
    type: Types.getCampaignFields,
    payload: { campaignId }
  }
}

export function updateCampaignFields ({ fields = [], error } = {}) {
  return {
    type: Types.updateCampaignFields,
    payload: { fields, error }
  }
}
